import { z } from 'zod'
import { refOn } from '@omnea-app/packages/universal/references/refKinds'
import { AssigneeTypeEnum } from '@omnea-app/packages/universal/users-and-groups/assigneeType'

// Shared so a consumer that wants a variant builds one from the same parts, rather than reaching for
// `.omit`/`.shape` — a union has neither.
export const assigneeFields = {
  value: z.string(),
  name: z.string().optional(),
  email: z.string().optional(),
  title: z.string().optional().nullable(),
  isOutOfOffice: z.boolean().optional(),
  isArchived: z.boolean().optional(),
}

export const UserAssigneeEntitySchema = z.object({
  type: z.literal(AssigneeTypeEnum.USER),
  id: refOn(z.string(), 'user'),
  ...assigneeFields,
})

export const VariableAssigneeEntitySchema = z.object({
  type: z.literal(AssigneeTypeEnum.VARIABLE),
  id: z.string(),
  ...assigneeFields,
})

// A union rather than one object, because `id` is a row of `users` or of `groups` for two of these and
// an email address or a question name for the others — one annotation could not say that.
export const AssigneeEntitySchema = z.discriminatedUnion('type', [
  UserAssigneeEntitySchema,
  z.object({ type: z.literal(AssigneeTypeEnum.GROUP), id: refOn(z.string(), 'group'), ...assigneeFields }),
  z.object({ type: z.literal(AssigneeTypeEnum.EMAIL), id: z.string(), ...assigneeFields }),
  VariableAssigneeEntitySchema,
])

export type AssigneeEntity = z.infer<typeof AssigneeEntitySchema>
export type VariableAssigneeEntity = z.infer<typeof VariableAssigneeEntitySchema>
